import React from 'react';
import CompanySearch from './CompanySearch'
import {
    useHistory
  } from "react-router-dom";
  
  function BottomNav()  {

    let history = useHistory();

    function onSubmit()
    {
      history.push("/find");
    }

    return <div className="row"><div className="col">
            <hr/>
            <footer >
                <div><strong>DEMO SITE.  NON-FUNCTIONAL.</strong></div>
            </footer>
            <hr/>
        </div></div>
    ;
  }

  export default BottomNav;


